import { EndRide } from "./../models/EndRide";
import { UnlockService } from "./../models/unlock.service";
import { StartRide } from "./../models/StartRide";
import { LockUnlockResult } from "./../models/lockunlockresult.model";
import { LockUnlock } from "./../models/lockunlock.model";
import { VehicleService } from "../../vehicle/models/vehicle.service";
import {
  BookingInformation,
  BookingTripDetail,
  Expense
} from "./../models/booking-information.model";
import { AuthService } from "./../../shared/models/auth.service";
import { TranslateService } from "./../../shared/translate/translate.service";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import { Component, OnInit, OnChanges, Input, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  IKeyValueInterface,
  WeGoAuthorizedLink,
  PermissionType,
  Permission,
  Entity,
  RoleLevel
} from "./../../shared/config";
import { BookingService } from "./../models/booking.service";
import {
  WeGoConfig,
  IAPIResponse,
  DataListModel,
  ApplicationRouteURL,
  BookingStatus
} from "../../shared/config";
import { Location } from "@angular/common";

const moment = require("moment");

@Component({
  selector: "wego-booking-information",
  template: require('../views/booking-information.component.html'),
  styles: [
    `
      span.label.label-default {
        font-size: 13px;
        line-height: 35px;
        background-color: #eeeeee;
        color: #2ba2aa;
        margin-right: 5px;
      }

      span.label.label-default.text-success {
        color: #3c763d;
      }

      span.label.label-default.text-danger {
        color: #a94442;
      }

      .line {
        border-top: 1px solid #000;
      }
    `
  ],
  providers: [BookingService, UnlockService, VehicleService]
})
export class BookingInformationComponent implements OnInit {
  withVehicleInfo: boolean = false;
  viewEventViewerLink: WeGoAuthorizedLink;
  viewVehicleLink: WeGoAuthorizedLink;
  updateSvgLink: WeGoAuthorizedLink;
  updateVehicleLink: WeGoAuthorizedLink;
  vtsTroubleShootLink: WeGoAuthorizedLink;
  apiErrorMsg: string;
  sub: any;
  readMore: IKeyValueInterface[];
  isLoading: boolean;
  message: string;
  popupTitle: string;
  model: BookingInformation;
  urlBooking: string;
  urlBookingTrips: string;
  urlCostsSummary: string;
  urlDefaultPage: string;
  bookingHashId: string;
  urlBookingOverView: string;
  bookingExtensionValidation: string;
  bookingExtendTime: number;
  availableBookingExtandTime: number;
  bookingExtandInfoMsg: string;
  private popupMsg: string;
  private module: string;
  lockunlock: LockUnlock;
  lockunlockresult: LockUnlockResult;
  startride: StartRide;
  referenceID: string;
  contacttypegroupid: number;
  contacttpyegroupList: any;
  triphashId: string;
  endride: EndRide;
  isContractTypeGroupAvailable: boolean;
  urlVehicleInfo: string;
  urlSVGInfo: string;
  deleteMessage: string;
  bookingtripHashId: string;
  urlVtsTroubleShoot: string;
  urlEventViewer: string;
  roleLevel = RoleLevel;

  @ViewChild("alertModal") public alertModal: any;
  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("validationModal") public validationModal: any;
  @ViewChild("reportDamageModal") public reportDamageModal: any;
  @ViewChild("bookingTripDetailModal") public bookingTripDetailModal: any;
  @ViewChild("confirmModal") public confirmModal: any;
  @ViewChild("updateSuccessPopup") public updateSuccessPopup: any;
  @ViewChild("bookingExpenseModel") public bookingExpenseModel: any;
  @ViewChild("receiptImagePopup") public receiptImagePopup: any;
  @ViewChild("freebookingModal") public freebookingModal: any;

  constructor(
    private authService: AuthService,
    private bookigService: BookingService,
    private unlockService: UnlockService,
    private router: Router,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private locationService: Location,
    private vehicleService: VehicleService
  ) { }

  ngOnInit() {
    this.model = new BookingInformation();
    this.lockunlock = new LockUnlock();
    this.startride = new StartRide();
    this.endride = new EndRide();
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlBooking = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING);
    this.urlBookingTrips = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING_INFORMATION2);
    this.urlCostsSummary = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING_INFORMATION3);
    this.urlBookingOverView = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_OVERVIEW
    );
    this.urlVehicleInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_INFO
    );
    this.urlSVGInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_SVG_UPDATE
    );
    this.urlVtsTroubleShoot = this.authService.GetURL(
      ApplicationRouteURL.URL_VTS_TROUBLESHOOT
    );
    this.urlEventViewer = this.authService.GetURL(
      ApplicationRouteURL.URL_EVENT_VIEWER_LIST
    );
    
    this.activeRoute.queryParams.subscribe(queryParams =>{
      this.withVehicleInfo = queryParams['vehicleInfo'] == 'true';
      this.sub = this.activeRoute.params.subscribe(params => {
        this.bookingHashId = params["id"] || "";
        if (this.bookingHashId != "") {
          this.GetBookingInformation();
        }
      });  
    })
    
  }

  
  public GetContactTypeGroup() {
    this.unlockService.GetContactTypeGroupList(this.bookingHashId).subscribe(
      (res: any) => {
        console.log(res.data);
        this.contacttpyegroupList = res.data;
        if (this.contacttpyegroupList.length > 0) {
          if (
            this.contacttpyegroupList &&
            this.contacttpyegroupList.length > 1
          ) {
            this.contacttypegroupid = this.contacttpyegroupList.filter(
              (x: any) => x.isSelected
            )[0].contactTypeGroupId;
            console.log(this.contacttypegroupid);
            this.isContractTypeGroupAvailable = true;
          } else {
            this.contacttypegroupid = this.contacttpyegroupList[0].contactTypeGroupId;
            this.isContractTypeGroupAvailable = false;
          }
        }
      },
      (error: any) => { }
    );
  }

  private GetBookingInformation() {
    this.isLoading = true;
    this.bookigService
      .GetBookingInformationByHashId(this.bookingHashId, 'page1')
      .subscribe(
          (res: any)=> {
          if (res.data) {
            this.model = res.data;

            this.vtsTroubleShootLink = new WeGoAuthorizedLink(
              this.urlVtsTroubleShoot + "/" + this.model.vehicleHashId,
              Permission.PR_VTS_TROUBLESHOOT,
              PermissionType.VIEW,
              "",
              "LblTroubleShootVTS",
              "",
              "",
              false,
              "fa fa-wrench"
            );

            this.viewVehicleLink = new WeGoAuthorizedLink(
              this.urlVehicleInfo + "/" + this.model.vehicleHashId,
              Permission.PR_VEHICLES_OVERVIEW,
              PermissionType.VIEW,
              "",
              this.model.licenceTag,
              "",
              "",
              true
            );

            this.updateSvgLink = new WeGoAuthorizedLink(
              this.urlSVGInfo + "/" + this.model.sharedVehicleGroupHashId,
              Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW,
              PermissionType.EDIT,
              "",
              this.model.sharedVehicleGroup,
              Entity.SVG,
              this.model.sharedVehicleGroupHashId,
              true
            );

            this.viewEventViewerLink = new WeGoAuthorizedLink(
              this.urlEventViewer +
              "?filter ='BOOKING'& searchTerm= " +
              this.model.bookingReferenceID,
              Permission.PR_EVENT_VIEWER,
              PermissionType.VIEW,
              "",
              "LblEventViewer",
              "",
              "",
              false
            );

            this.isLoading = false;
          }
        },
          (error:any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        },
        () => (this.contacttpyegroupList = this.GetContactTypeGroup())
      );
  }

  private CheckBookingExtendTime() {
    this.isLoading = true;
    this.bookigService.CheckBookingExtendTime(this.bookingHashId).subscribe(
        (res:any) => {
        if (res.data > 0) {
          this.availableBookingExtandTime = res.data;
          this.bookingExtandInfoMsg = this.translate.instant(
            "LblExtendInfoMsg",
            this.availableBookingExtandTime.toString()
          );
        } else {
          this.bookingExtandInfoMsg = this.translate.instant(
            "LblExtendValidationMsg"
          );
        }
        this.ShowAlertModal();
        this.isLoading = false;
      },
        (error:any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnBackClick() {
    this.router.navigate([this.urlBookingOverView]);
  }

  public OnTripsClick(bookingIdHashId: string) {
    var url = this.urlBookingTrips + '/' + bookingIdHashId;
    this.router.navigateByUrl(url); 
  }
  public OnCostsSummaryClick(bookingIdHashId: string) {    
    var url = this.urlCostsSummary + '/' + bookingIdHashId;
    this.router.navigateByUrl(url);
  }


  

  public StartBooking(bookingExternalId: string) {
    this.isLoading = true;
    this.bookigService.StartBooking(bookingExternalId).subscribe(
        (res:any) => {
        if (res.bookingStatus == 'running') {  
          this.message = this.translate.instant("LblBookingStarted");
          this.popupTitle = this.translate.instant("LblSuccess");
          this.validationModal.show();

          setTimeout(function(){ window.location.reload(); }, 1000);
        } else {
          this.popupTitle = this.translate.instant('LblWarning');
          this.bookingExtandInfoMsg = this.translate.instant('LblCouldnotStartBooking'); 
        }
        this.ShowAlertModal();
        this.isLoading = false;
      },
        (error:any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }


  public StopBooking(bookingExternalId: string) {
    this.isLoading = true;
    this.bookigService.StopBooking(bookingExternalId).subscribe(
        (res:any) => {
        if (res.bookingStatus == 'stopped') {  
          this.message = this.translate.instant("LblBookingStopped");
          this.popupTitle = this.translate.instant("LblSuccess");
          this.validationModal.show();

          setTimeout(function(){ window.location.reload(); }, 1000);
        } else {
          this.popupTitle = this.translate.instant('LblWarning');
          this.bookingExtandInfoMsg = this.translate.instant('LblCouldnotStopBooking'); 
        }
        this.ShowAlertModal();
        this.isLoading = false;
      },
        (error:any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }


  public LockVTSVehicle(locationDataExchangeHashId: string) {
    this.isLoading = true;
    this.vehicleService.LockVTSVehicle(locationDataExchangeHashId, false)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.data) {
            this.message = this.translate.instant("LblLockSuccessfully");
            this.popupTitle = this.translate.instant("LblSuccess");
            this.validationModal.show();
          }
          else {

            if (res.error.toUpperCase() == "ACTION ABORTED, ENGINE STILL RUNNING") {
              this.popupMsg = this.translate.instant("LblEngineStillRunning");
              this.popupTitle = this.translate.instant("LblWarning");
            } else {
              this.popupMsg = this.translate.instant('LbllockProblem');
              this.popupTitle = this.translate.instant('LblWarning');
            }
             
            this.validationModal.show();
          }
        },
        (error: any) => {
          this.isLoading = false;
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        });
  }
  public UnLockVTSVehicle(locationDataExchangeHashId: string) {
    this.isLoading = true;
    this.vehicleService.UnLockVTSVehicle(locationDataExchangeHashId, false)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.data) { 
            this.message = this.translate.instant("LblUnLockSuccessfully");
            this.popupTitle = this.translate.instant("LblSuccess");
            this.validationModal.show();
          }
          else {
            this.popupMsg = this.translate.instant('LblUnlockProblem');
            this.popupTitle = this.translate.instant('LblWarning');
            this.validationModal.show();
          }
        },
        (error: any) => {
          this.isLoading = false;
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        });
  }

  public ShowAlertModal(): void {
    this.bookingExtensionValidation = "";
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.bookingExtensionValidation = "";
    this.bookingExtendTime = null;
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    if (this.availableBookingExtandTime > 0) {
      if (this.bookingExtendTime && this.bookingExtendTime > 0) {
        if (this.bookingExtendTime > this.availableBookingExtandTime) {
          this.bookingExtensionValidation = this.translate.instant(
            "LblOverExtendValidationMsg",
            this.availableBookingExtandTime.toString()
          );
        } else {
          this.bookingExtensionValidation = "";
          this.ExtendOnGoingBooking();
          this.HideAlertModal();
        }
      } else {
        this.bookingExtensionValidation = this.translate.instant(
          "LblExtendRequire"
        );
      }
    } else {
      this.bookingExtensionValidation = "";
      this.HideAlertModal();
    }
  }

  private ExtendOnGoingBooking() {
    this.isLoading = true;
    this.bookigService
      .ExtendOnGoingBooking(this.bookingHashId, this.bookingExtendTime)
      .subscribe(
          (res:any) => {
          if (res.data) {
            this.popupMsg = this.translate.instant("LblBookingExtendedSuccess");
            this.isLoading = false;
            this.ShowSuccessPopup();
          }
        },
          (error:any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }
  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.router.navigate([this.urlBookingOverView]);
  }
  public HideValidationModal(): void {
    this.validationModal.hide();
  }
  public UnlockVehicle(bookingIdHashId: string, vehicleExchangeHashId: string) {
    this.lockunlock.bookingMasterHashId = bookingIdHashId;
    this.lockunlock.contractTypeGroupId = this.contacttypegroupid;
    this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
    this.lockunlock.isMobileRequest = false;
    if (this.contacttpyegroupList && this.contacttpyegroupList.length > 0) {
      this.isLoading = true;
      this.unlockService.UnlockVehicle(this.lockunlock).subscribe(
        (res: any) => {
          if (res.data) {
            this.lockunlockresult = res.data;
            if (this.lockunlockresult.isTripCalculatingInProgress) {
              this.isLoading = false;
              this.message = this.translate.instant(
                "LblTripCalculationInProgress"
              );
              this.popupTitle = this.translate.instant("LblWarning");
              this.validationModal.show();
            } else if (this.lockunlockresult.isBookingExpired) {
              this.isLoading = false;
              this.message = this.translate.instant("LblBookingExpired");
              this.popupTitle = this.translate.instant("LblWarning");
              this.validationModal.show();
            } else if (this.lockunlockresult.isSameCommandInProgress) {
              this.isLoading = false;
              this.message = this.translate.instant("LblSameVTSCommand");
              this.popupTitle = this.translate.instant("LblWarning");
              this.validationModal.show();
            } else if (this.lockunlockresult.isDoorStatusOpened) {
              this.isLoading = false;
              this.popupMsg = this.translate.instant("LblUnLockSuccessfully");
              this.ShowSuccessPopup();
            } else if (
              !this.lockunlockresult.isUnlock &&
              !this.lockunlockresult.isTripCalculatingInProgress &&
              !this.lockunlockresult.isSameCommandInProgress
            ) {
              this.isLoading = false;
              this.message = this.translate.instant("LblUnlockProblem");
              this.popupTitle = this.translate.instant("LblWarning");
              this.validationModal.show();
            } else if (this.lockunlockresult.isUnlock) {
              //this.GetStartRideSubmit();
              this.isLoading = false;
              this.popupMsg = this.translate.instant("LblUnLockSuccessfully");
              this.ShowSuccessPopup();
            }
          }
        },
        (error: any) => {
          this.isLoading = false;
        }
      );
    } else {
      this.message = this.translate.instant("LblUnlockErrorMessage");
      this.popupTitle = this.translate.instant("LblWarning");
      this.validationModal.show();
    }
  }

  // public GetStartRideSubmit() {
  //   this.isLoading = true;
  //   this.startride.contractTypeGroupId = this.contacttypegroupid;
  //   this.startride.startDateTime = this.lockunlockresult.startDateTime;
  //   this.startride.startLatitude = this.lockunlockresult.startLat;
  //   this.startride.startLongitude = this.lockunlockresult.startLog;
  //   this.startride.startMileage = this.lockunlockresult.startMilege;
  //   this.startride.bookingHashId = this.bookingHashId;
  //   this.startride.locationExchangeHashId = this.lockunlock.locationDataExchangeHashId;
  //   this.startride.bookingTripSummaryId = this.lockunlockresult.bookingTripSummaryId;
  //   let tripcommandproblem = this.translate.instant('LblProblemTrip');
  //   this.unlockService.StartTrip(this.startride)
  //     .subscribe(
  //     res => {
  //       if (res.data) {
  //         this.triphashId = res.data;
  //         this.isLoading = false;
  //         this.popupMsg = this.translate.instant('LblUnLockSuccessfully');
  //         this.ShowSuccessPopup();
  //       }
  //       else {
  //         this.isLoading = false;
  //       }
  //     },
  //     error => {
  //       this.isLoading = false;
  //     });
  // }

  private LockVehicle(bookingIdHashId: string, vehicleExchangeHashId: string) {
    this.lockunlock.bookingMasterHashId = bookingIdHashId;
    this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
    this.lockunlock.isMobileRequest = false;
    this.isLoading = true;
    this.unlockService.LockVehicle(this.lockunlock).subscribe(
        (res:any) => {
        if (res.data) {
          this.lockunlockresult = res.data;
          if (this.lockunlockresult.isBookingExpired) {
            this.isLoading = false;
            this.message = this.translate.instant("LblBookingExpired");
            this.popupTitle = this.translate.instant("LblWarning");
            this.validationModal.show();
          } else if (this.lockunlockresult.isSameCommandInProgress) {
            this.isLoading = false;
            this.message = this.translate.instant("LblSameVTSCommand");
            this.popupTitle = this.translate.instant("LblWarning");
            this.validationModal.show();
          } else if (this.lockunlockresult.isDoorStatusClosed) {
            this.popupMsg = this.translate.instant(
              "LblLockCompletelySuccessfully"
            );
            this.isLoading = false;
            this.ShowSuccessPopup();
          } else if (
            !this.lockunlockresult.isLock &&
            !this.lockunlockresult.isSameCommandInProgress
          ) {
            this.isLoading = false;
            this.message = this.translate.instant("LbllockProblem");
            this.popupTitle = this.translate.instant("LblWarning");
            this.validationModal.show();
          } else {
            //this.GetEndRideSubmit(bookingIdHashId, vehicleExchangeHashId);
            this.popupMsg = this.translate.instant(
              "LblLockCompletelySuccessfully"
            );
            this.isLoading = false;
            this.ShowSuccessPopup();
          }
        } else {
        }
      },
        (error:any) => {
        this.isLoading = false;
      }
    );
  }

  private PartialockResult(
    bookingIdHashId: string,
    vehicleExchangeHashId: string
  ) {
    this.lockunlock.bookingMasterHashId = bookingIdHashId;
    this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
    this.lockunlock.tripHashId = this.triphashId
      ? this.triphashId.toString()
      : "0";
    this.lockunlock.isMobileRequest = false;
    this.isLoading = true;
    this.unlockService.PartialLock(this.lockunlock).subscribe(
        (res:any) => {
        if (res.data) {
          this.lockunlockresult = res.data;
          if (this.lockunlockresult.isBookingExpired) {
            this.isLoading = false;
            this.message = this.translate.instant("LblBookingExpired");
            this.popupTitle = this.translate.instant("LblWarning");
            this.validationModal.show();
          } else if (this.lockunlockresult.isSameCommandInProgress) {
            this.isLoading = false;
            this.message = this.translate.instant("LblSameVTSCommand");
            this.popupTitle = this.translate.instant("LblWarning");
            this.validationModal.show();
          } else if (this.lockunlockresult.isDoorStatusClosed) {
            this.popupMsg = this.translate.instant(
              "LblLockCompletelySuccessfully"
            );
            this.isLoading = false;
            this.ShowSuccessPopup();
          } else if (this.lockunlockresult.engineStillRunning) {
            this.isLoading = false;
            this.message = this.translate.instant("LblEngineStillRunning");
            this.popupTitle = this.translate.instant("LblWarning");
            this.validationModal.show();
          } else if (!this.lockunlockresult.isLock) {
            this.isLoading = false;
            this.message = this.translate.instant("LbllockProblem");
            this.popupTitle = this.translate.instant("LblWarning");
            this.validationModal.show();
          }
          else {
            this.popupMsg = this.translate.instant("LblLockSuccessfully");
            this.isLoading = false;
            this.ShowSuccessPopup();
          }
        }
      },
        (error:any) => {
        this.isLoading = false;
      }
    );
  }

  // public GetEndRideSubmit(bookingIdHashId: string, vehicleExchangeHashId: string) {
  //   this.endride.bookingHashId = bookingIdHashId;
  //   this.endride.tripHashId = this.triphashId ? this.triphashId.toString() : '0';
  //   this.endride.locationExchangeHashId = vehicleExchangeHashId;
  //   this.unlockService.EndTrip(this.endride)
  //     .subscribe(
  //     res => {
  //       if (res.data) {
  //         this.lockunlockresult = res.data;
  //       }
  //       else {

  //       }
  //     },
  //     error => {
  //     });
  // }

  public ReportDamage(bookingHashId: string) {
    this.reportDamageModal.model.bookingHashId = bookingHashId;
    this.reportDamageModal.model.vehicleHashId = this.model.vehicleHashId;
    this.reportDamageModal.show();
  }
  public FreeBooking(bookingHashId: string) {
    this.freebookingModal.model.bookingHashId = bookingHashId;
    this.freebookingModal.show();
  }
  public SuccessReportDamage(successMsg: string) {
    this.popupMsg = successMsg;
    this.ShowSuccessPopup();
  }

  public SuccessSave(successMsg: string) {
    this.popupMsg = successMsg;
    this.ShowUpdateSuccessPopup();
    this.GetBookingInformation();
  }

  public AddTripDetail() {
    this.bookingTripDetailModal.model = new BookingTripDetail();
    this.bookingTripDetailModal.show();
  }
  public EditTripDetail(bookingtrip: BookingTripDetail) {
    this.bookingTripDetailModal.model = JSON.parse(JSON.stringify(bookingtrip));
    this.bookingTripDetailModal.show();
  }

  public ShowConfirmModal(bookingtripHashId: string): void {
    this.isLoading = false;
    this.deleteMessage = this.translate.instant(
      "LblRecordDeleteConfirmation",
      this.translate.instant("LblBookingTripDetail")
    );
    this.confirmModal.show();
    this.bookingtripHashId = bookingtripHashId;
  }

  public HideConfirmModal(): void {
    this.confirmModal.hide();
  }

  public ConfirmSuccessClick(): void {
    this.confirmModal.hide();
    //this.DeleteBookingTrip();
  }

  // public DeleteBookingTrip() {
  //   this.isLoading = true;
  //   this.bookigService.DeleteBookingTrip(this.bookingtripHashId)
  //     .subscribe(
  //     (res: any) => {
  //       if (res.data) {
  //         this.GetBookingInformation();
  //         this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', this.translate.instant('LblBookingTripDetail'));
  //         this.ShowUpdateSuccessPopup();
  //       }
  //       else {
  //         this.popupMsg = res.error;
  //         this.isLoading = false;
  //         this.ShowUpdateSuccessPopup();
  //       }
  //     },
  //     (error: any) => {
  //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
  //       this.isLoading = false;
  //     });
  // }

  public ShowUpdateSuccessPopup(): void {
    this.updateSuccessPopup.show();
  }

  public HideUpdateSuccessPopup(): void {
    this.updateSuccessPopup.hide();
  }

  public ConfirmUpdateSuccessPopup(): void {
    this.updateSuccessPopup.hide();
  }

  public EditExpenseDetail(bookingexpense: Expense) {
    this.bookingExpenseModel.model = JSON.parse(JSON.stringify(bookingexpense));
    this.bookingExpenseModel.show();
  }

  public ShowReceipt(imagepath: string) {
    this.receiptImagePopup.imagepath = WeGoConfig.API_SERVER_URL + imagepath;
    this.receiptImagePopup.show();
  }

  public GroupByCategory(vehicleAttributeList: any) {
    if (vehicleAttributeList) {
      let prop = "vehicleAttributeCategoryName";
      return vehicleAttributeList.reduce(function (groups: any, item: any) {
        let val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        groups[val] = groups[val].sort((obj1: any, obj2: any) => {
          if (obj1.attributeName > obj2.attributeName) {
            return 1;
          }

          if (obj1.attributeName < obj2.attributeName) {
            return -1;
          }
          return 0;
        });
        return groups;
      }, {});
    } else {
      return {};
    }
  }

  public KeyOfObject(obj: any) {
    return Object.keys(obj);
  }

  public CalculateTripCost(dataArray: any, propName: string) {
    let total: number = 0;

    for (var n = 0; n < dataArray.length; n++) {
      total += dataArray[n][propName];
    }

    return Math.round(total * 100) / 100;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/booking-information.component.ts